import { addUnits } from "./utils/addUnits";

const _setWidth= (el: HTMLElement, height: string | number) => {
  if (!el){
    return
  }
  el.style.width = addUnits(height);
}
export function setWidth (els: string | HTMLElement | NodeListOf<HTMLElement>, value: string | number) {
  if (typeof els === 'string') {
    els = document.querySelectorAll(els);
    els.forEach(it => {
      _setWidth(it, value)
    })
  } else if (els instanceof NodeList) {
    els.forEach(it => {
      _setWidth(it, value)
    })
  } else {
    _setWidth(els, value)
  }

}